var _path, _path2, _path3, _g, _path4, _path5, _path6, _path7, _path8, _path9, _g2, _g3, _g4, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgElephant(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 357,
    height: 551,
    viewBox: "0 0 357 551",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M-177.288 244.614C-124.8 210.666 -52.438 223.851 -1.30438 259.832C15.371 271.723 30.7541 285.401 44.4144 300.681C52.4136 309.43 59.9821 318.672 67.243 328.16C69.0274 330.501 70.8119 332.843 72.5348 335.246C73.7039 336.848 74.9345 338.449 76.1037 340.113C90.81 360.568 104.286 382.071 117.454 403.389C150.374 456.56 184.155 511.395 234.304 548.732C244.642 556.434 259.04 563.334 269.624 556.002C278.792 549.595 279.223 536.225 277.131 525.196C269.378 484.47 241.319 450.707 211.537 421.872C181.755 393.038 148.774 366.668 126.314 331.795C103.793 296.984 93.5174 250.467 113.269 214.054C130.252 182.632 166.803 165.011 202.492 164.21C238.181 163.409 272.824 177.272 302.975 196.372C333.126 215.471 359.708 239.623 387.397 262.174C404.073 275.79 427.394 289.283 445.607 277.761C460.99 268.027 462.16 244.676 452.991 228.965C443.823 213.253 427.517 203.334 411.826 194.154C363.153 165.566 314.543 136.916 265.87 108.328C250.918 99.5788 235.719 90.5218 224.643 77.152C213.629 63.7821 207.476 44.9904 213.568 28.7864C219.536 12.7672 236.273 2.6628 253.256 0.506367C270.178 -1.58845 287.222 3.09408 303.098 9.44014C362.415 33.2841 502.094 189.348 539.321 216.026C563.258 233.154 588.363 254.842 590.824 284.231C593.839 320.767 557.535 351.08 521.046 354.654C484.619 358.227 449.299 342.331 416.687 325.573C384.136 308.814 350.909 290.33 314.358 287.989C277.808 285.648 236.827 305.24 228.151 340.852C220.644 371.843 239.781 403.82 264.701 423.659C284.207 439.185 307.159 449.536 329.311 461.181C335.464 464.385 341.556 467.712 347.463 471.285C362.661 480.404 376.875 491.125 389.859 503.201C403.457 515.831 415.702 529.94 426.348 545.22C434.839 557.358 442.223 570.296 448.438 583.728C449.361 585.761 450.284 587.856 451.207 589.951C452.068 591.984 452.868 594.017 453.668 596.112C463.821 622.913 467.759 652.98 454.837 677.994C441.915 702.947 413.856 717.734 385.859 719.768C369.676 720.753 353.431 718.597 338.048 713.422C326.726 709.725 315.773 705.042 305.313 699.312C256.825 673.25 218.429 631.909 183.355 589.458C148.281 547.007 115.3 502.276 73.7039 466.172C32.1078 430.128 -20.0719 402.834 -75.082 403.266C-130.092 403.697 -186.825 437.275 -202.455 490.077C-225.468 450.645 -240.851 405.853 -238.82 360.445C-236.79 315.037 -215.376 269.259 -177.288 244.614Z",
    fill: "#F4EFFE"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M41.0453 241.232C39.9105 240.732 39.5971 239.905 40.105 238.752L41.7253 235.073L38.1287 233.489C37.0305 233.005 36.7193 232.224 37.1949 231.144C37.6705 230.064 38.4574 229.766 39.5556 230.249L43.1522 231.834L44.7122 228.292C45.212 227.157 46.0293 226.84 47.1641 227.339C48.2989 227.839 48.6164 228.656 48.1166 229.791L46.5566 233.333L50.1532 234.917C51.2514 235.401 51.5627 236.183 51.0871 237.262C50.6115 238.342 49.8245 238.64 48.7263 238.157L45.1297 236.573L43.5094 240.252C43.0015 241.405 42.1801 241.731 41.0453 241.232ZM52.8498 247.447C52.0444 247.092 51.5393 246.651 51.3345 246.124C51.156 245.586 51.228 244.952 51.5505 244.219C51.7762 243.707 52.0876 243.298 52.4846 242.992C52.8815 242.686 53.3569 242.425 53.9105 242.21L60.9281 239.302C61.9724 238.866 62.7619 238.438 63.2966 238.018C63.8577 237.588 64.2592 237.098 64.501 236.549C65.1137 235.158 64.5323 234.071 62.7569 233.289C62.3176 233.096 61.8135 232.95 61.2446 232.853C60.702 232.745 60.0917 232.716 59.4136 232.767C58.8146 232.788 58.334 232.663 57.9716 232.394C57.6173 232.107 57.3805 231.752 57.2613 231.328C57.1421 230.904 57.1346 230.474 57.2388 230.039C57.3612 229.612 57.5986 229.247 57.9509 228.943C58.3113 228.621 58.7859 228.437 59.3746 228.39C60.4101 228.322 61.4205 228.384 62.4061 228.578C63.418 228.762 64.3815 229.055 65.2967 229.458C67.5297 230.441 69.0183 231.676 69.7624 233.162C70.5249 234.656 70.503 236.319 69.6968 238.149C69.1809 239.32 68.4237 240.32 67.4254 241.148C66.427 241.975 65.0355 242.728 63.2507 243.407L58.7423 245.158L64.2058 247.564C65.5969 248.177 65.9941 249.161 65.3976 250.515C64.793 251.888 63.7951 252.268 62.4041 251.655L52.8498 247.447Z",
    fill: "#F4EFFE"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M266.59 353.651C265.712 353.989 264.953 353.938 264.313 353.499C263.672 353.059 263.385 352.313 263.451 351.259L264.646 333.569C264.702 332.711 264.907 332.021 265.263 331.499C265.619 330.976 266.124 330.589 266.777 330.337C267.412 330.093 268.036 330.046 268.651 330.195C269.266 330.344 269.881 330.718 270.497 331.316L283.245 343.64C284.026 344.389 284.336 345.138 284.174 345.886C284.005 346.615 283.5 347.142 282.66 347.465C281.913 347.752 281.27 347.807 280.73 347.629C280.209 347.444 279.646 347.039 279.041 346.415L277.326 344.632L268.507 348.027L268.43 350.499C268.382 351.375 268.245 352.049 268.019 352.522C267.794 352.994 267.317 353.371 266.59 353.651ZM268.887 335.986L268.667 343.432L274.099 341.342L268.943 335.965L268.887 335.986ZM295.776 342.481C294.861 342.833 293.946 342.96 293.03 342.863C292.132 342.758 291.371 342.451 290.747 341.942C291.136 343.399 290.603 344.408 289.147 344.968C287.504 345.6 286.36 345.077 285.713 343.397L279.862 328.194C279.215 326.514 279.713 325.358 281.355 324.726C282.158 324.417 282.857 324.395 283.451 324.659C284.064 324.915 284.529 325.455 284.845 326.276L286.903 331.623C287.065 330.875 287.442 330.184 288.034 329.549C288.644 328.907 289.378 328.421 290.237 328.09C291.431 327.63 292.588 327.517 293.707 327.751C294.844 327.978 295.873 328.535 296.793 329.424C297.707 330.294 298.451 331.475 299.026 332.968C299.593 334.443 299.824 335.822 299.718 337.106C299.631 338.382 299.241 339.486 298.55 340.417C297.876 341.34 296.952 342.028 295.776 342.481ZM292.796 339.417C293.543 339.129 294.051 338.612 294.321 337.865C294.591 337.119 294.488 336.129 294.014 334.897C293.533 333.647 292.945 332.844 292.252 332.49C291.551 332.117 290.827 332.074 290.081 332.361C289.315 332.656 288.798 333.176 288.528 333.923C288.251 334.651 288.353 335.641 288.835 336.891C289.309 338.123 289.896 338.926 290.597 339.299C291.298 339.672 292.031 339.711 292.796 339.417ZM311.094 336.585C309.545 337.181 308.08 337.413 306.7 337.279C305.339 337.139 304.133 336.65 303.081 335.811C302.03 334.973 301.217 333.807 300.642 332.314C300.067 330.821 299.893 329.42 300.118 328.112C300.336 326.785 300.906 325.623 301.829 324.624C302.764 323.6 304.005 322.79 305.555 322.194C306.096 321.986 306.687 321.822 307.327 321.705C307.96 321.568 308.648 321.518 309.391 321.553C309.884 321.556 310.293 321.699 310.616 321.982C310.932 322.246 311.147 322.581 311.26 322.987C311.393 323.386 311.417 323.784 311.334 324.18C311.269 324.57 311.081 324.888 310.77 325.137C310.477 325.378 310.076 325.479 309.568 325.439C308.844 325.396 308.165 325.497 307.531 325.741C306.541 326.122 305.891 326.715 305.58 327.52C305.268 328.326 305.321 329.27 305.738 330.353C306.162 331.454 306.763 332.208 307.541 332.616C308.312 333.005 309.193 333.009 310.182 332.628C310.48 332.513 310.778 332.367 311.073 332.189C311.362 331.992 311.636 331.758 311.896 331.486C312.265 331.108 312.633 330.924 313.001 330.932C313.38 330.915 313.724 331.029 314.033 331.275C314.353 331.494 314.598 331.796 314.767 332.181C314.955 332.559 315.024 332.961 314.974 333.387C314.917 333.795 314.697 334.169 314.313 334.51C313.787 335.034 313.252 335.454 312.709 335.77C312.174 336.105 311.635 336.376 311.094 336.585Z",
    fill: "#F4EFFE"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_0_1)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M94.1431 544.224C93.8926 581.781 127.316 623.802 168.88 624.084C210.46 624.366 244.448 582.815 244.698 545.242C244.949 507.684 211.384 488.326 169.804 488.044C128.224 487.762 94.3936 506.651 94.1274 544.208L94.1431 544.224Z",
    fill: "url(#paint0_linear_0_1)"
  }))), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M218.857 506.908L218.843 506.915C211.029 510.814 207.854 520.313 211.751 528.131L234.154 573.064C238.052 580.881 247.546 584.058 255.361 580.158L255.375 580.151C263.189 576.252 266.364 566.753 262.466 558.935L240.064 514.003C236.166 506.185 226.671 503.008 218.857 506.908Z",
    fill: "url(#paint1_linear_0_1)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M110.95 563.91L114.887 561.946C122.701 558.046 125.876 548.548 121.978 540.73L94.5024 485.622C90.6046 477.804 81.11 474.628 73.2957 478.527L69.3591 480.492C61.5448 484.391 58.3698 493.89 62.2676 501.708L89.7432 556.816C93.641 564.633 103.136 567.81 110.95 563.91Z",
    fill: "url(#paint2_linear_0_1)"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M118.375 386.445L93.2799 371.159C85.6089 366.476 75.9654 366.445 68.2631 371.081C55.2537 378.88 45.4693 391.081 40.6788 405.474C32.726 429.328 43.3715 455.405 65.727 466.869L90.5872 479.618L118.359 386.445H118.375Z",
    fill: "#9E83FF"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M113.68 400.588L92.812 387.886C86.4248 384.002 78.4094 383.97 72.0064 387.823C61.2044 394.307 53.0638 404.456 49.0874 416.406C42.481 436.234 51.3261 457.911 69.9243 467.449L90.589 478.052L113.68 400.588Z",
    fill: "url(#paint3_linear_0_1)"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M205.574 386.445L230.669 371.159C238.34 366.476 247.984 366.445 255.686 371.081C268.68 378.88 278.464 391.081 283.255 405.459C291.208 429.312 280.562 455.389 258.207 466.854L233.346 479.603L205.574 386.43V386.445Z",
    fill: "#9E83FF"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M210.271 400.588L231.139 387.886C237.526 384.002 245.542 383.97 251.945 387.823C262.747 394.307 270.887 404.456 274.864 416.406C281.47 436.234 272.625 457.911 254.027 467.449L233.362 478.052L210.271 400.588Z",
    fill: "url(#paint4_linear_0_1)"
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter1_d_0_1)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M245.731 460.479C245.731 506.761 208.237 527.513 161.976 527.513C115.715 527.513 78.2212 506.761 78.2212 460.479C78.2212 414.198 129.852 364.503 161.976 364.503C194.1 364.503 245.731 414.198 245.731 460.479Z",
    fill: "url(#paint5_linear_0_1)"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter2_d_0_1)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M144.144 370.47C151.533 376.14 151.658 392.647 151.658 392.647C151.83 393.211 152.629 393.023 152.895 392.851C154.038 392.115 156.668 388.904 156.668 388.904C156.997 388.434 157.701 388.544 157.889 389.076C157.889 389.076 159.627 395.059 160.018 400.431C160.049 400.776 161.083 400.588 161.349 400.4C163.838 398.599 165.936 388.716 165.936 388.716C166.092 388.168 166.781 388.027 167.141 388.45C167.141 388.45 169.959 389.734 171.431 393.587C171.54 393.885 172.417 393.493 172.652 393.274C177.333 388.983 180.182 372.725 176.675 367.667C171.697 360.478 137.287 365.192 144.144 370.454V370.47Z",
    fill: "#8058EA"
  }))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter3_d_0_1)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M92.0283 506.917L93.3276 503.143C94.3139 500.276 97.6015 498.71 100.294 500.088C100.482 500.182 106.775 508.389 110.752 510.504C115.119 512.837 122.9 511.929 128.63 504.333C136.238 494.247 135.127 480.511 140.387 474.074C149.639 462.782 162.93 462.265 173.231 468.639C183.517 475.014 187.712 489.25 182.969 500.48C178.241 511.678 157.67 527.372 146.711 532.493C133.264 538.789 118.172 534.576 111.237 530.849C100.169 524.913 91.7465 514.372 91.7465 514.372C88.5528 512.133 89.9774 508.938 92.0283 506.917Z",
    fill: "url(#paint6_linear_0_1)"
  }))), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M129.381 473.918C142.782 473.918 153.646 459.893 153.646 442.594C153.646 425.294 142.782 411.27 129.381 411.27C115.98 411.27 105.116 425.294 105.116 442.594C105.116 459.893 115.98 473.918 129.381 473.918Z",
    fill: "white"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M196.698 473.918C210.1 473.918 220.964 459.893 220.964 442.594C220.964 425.294 210.1 411.27 196.698 411.27C183.297 411.27 172.433 425.294 172.433 442.594C172.433 459.893 183.297 473.918 196.698 473.918Z",
    fill: "white"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M146.603 440.15C146.603 434.095 141.696 429.187 135.644 429.187C129.592 429.187 124.686 434.095 124.686 440.15V451.114C124.686 457.169 129.592 462.077 135.644 462.077C141.696 462.077 146.603 457.169 146.603 451.114V440.15Z",
    fill: "#122431"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M133.296 444.849C136.322 444.849 138.775 442.395 138.775 439.367C138.775 436.34 136.322 433.885 133.296 433.885C130.27 433.885 127.817 436.34 127.817 439.367C127.817 442.395 130.27 444.849 133.296 444.849Z",
    fill: "#FEFFFF"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M201.396 440.15C201.396 434.095 196.489 429.187 190.437 429.187C184.385 429.187 179.479 434.095 179.479 440.15V451.114C179.479 457.169 184.385 462.077 190.437 462.077C196.489 462.077 201.396 457.169 201.396 451.114V440.15Z",
    fill: "#122431"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M188.089 444.849C191.115 444.849 193.568 442.395 193.568 439.367C193.568 436.34 191.115 433.885 188.089 433.885C185.063 433.885 182.61 436.34 182.61 439.367C182.61 442.395 185.063 444.849 188.089 444.849Z",
    fill: "#FEFFFF"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M218.616 484.552C217.066 493.495 208.44 500.778 197.372 502.876",
    stroke: "white",
    strokeWidth: 9,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_0_1",
    x: 86.1274,
    y: 483.041,
    width: 166.572,
    height: 152.044,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 3
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 4
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.258824 0 0 0 0 0 0 0 0 0 0.509804 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_0_1"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_0_1",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_d_0_1",
    x: 70.2212,
    y: 359.503,
    width: 183.509,
    height: 179.01,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 3
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 4
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.258824 0 0 0 0 0 0 0 0 0 0.509804 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_0_1"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_0_1",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter2_d_0_1",
    x: 141.244,
    y: 363,
    width: 38.9951,
    height: 40.6233,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 1
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.258824 0 0 0 0 0 0 0 0 0 0.509804 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_0_1"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_0_1",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter3_d_0_1",
    x: 81.8706,
    y: 459.541,
    width: 111.043,
    height: 87.1814,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 3
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 4
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.258824 0 0 0 0 0 0 0 0 0 0.509804 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_0_1"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_0_1",
    result: "shape"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_0_1",
    x1: 169.426,
    y1: 488.069,
    x2: 169.44,
    y2: 624.097,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A185FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.38,
    stopColor: "#AD95FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C9B8FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_0_1",
    x1: 226.078,
    y1: 504.651,
    x2: 223.249,
    y2: 579.977,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A185FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C9B8FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_0_1",
    x1: 102.468,
    y1: 566.048,
    x2: 105.749,
    y2: 478.698,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A185FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C9B8FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_0_1",
    x1: 113.68,
    y1: 431.504,
    x2: 46.9113,
    y2: 431.504,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A185FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C9B8FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_0_1",
    x1: 210.271,
    y1: 431.504,
    x2: 277.04,
    y2: 431.504,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A185FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C9B8FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_0_1",
    x1: 161.976,
    y1: 527.513,
    x2: 161.976,
    y2: 364.503,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A185FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C9B8FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_0_1",
    x1: 174.505,
    y1: 468.528,
    x2: 108.126,
    y2: 531.492,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A185FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.13,
    stopColor: "#A990FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.43,
    stopColor: "#BBA6FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.73,
    stopColor: "#C5B3FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C9B8FF"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgElephant);
export default __webpack_public_path__ + "static/media/elephant.8b0fc387858e9a1de7a54bc307a9b346.svg";
export { ForwardRef as ReactComponent };